// View-layer withdrawal predicates: share amounts are TokenAmount here, so comparisons read
// `.amount`. The status-only `isOpenWithdrawalStatus` stays in domain (used by the un-migrated queue).

import { EarnWithdrawalRequestStatus } from "../domain/earn-positions";
import { isOpenWithdrawalStatus } from "../domain/earn-withdrawals";
import { EarnVaultPositionResponseView, EarnWithdrawalRequestView } from "./earn-positions";

export function hasUnclaimedFilledShares(request: EarnWithdrawalRequestView): boolean {
    return request.sharesFilled.amount > request.sharesClaimed.amount;
}

export function isFulfilledUnclaimedWithdrawal(request: EarnWithdrawalRequestView): boolean {
    return request.status === EarnWithdrawalRequestStatus.Fulfilled && hasUnclaimedFilledShares(request);
}

/** Shares that left the wallet into the queue but aren't claimed yet (unfilled + filled-unclaimed). */
export function getOutstandingWithdrawalShares(requests: EarnWithdrawalRequestView[]): bigint {
    return requests.reduce((sum, request) => {
        if (isOpenWithdrawalStatus(request.status)) {
            return sum + request.sharesRequested.amount - request.sharesClaimed.amount;
        }
        if (isFulfilledUnclaimedWithdrawal(request)) {
            return sum + request.sharesFilled.amount - request.sharesClaimed.amount;
        }
        return sum;
    }, 0n);
}

// A closed position lingers with a 0-share record, so `response.position` existence alone isn't enough.
export function hasActiveEarnPosition(response: EarnVaultPositionResponseView | undefined): boolean {
    if (!response) return false;
    const hasShares = !!response.position && response.position.shareBalance.amount > 0n;
    const hasRelevantRequest = response.openWithdrawalRequests.some(
        (request) => isOpenWithdrawalStatus(request.status) || isFulfilledUnclaimedWithdrawal(request)
    );
    return hasShares || hasRelevantRequest;
}
